var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{attrs:{"id":"projects"}},[_c('div',{staticClass:"container"},[_c('carousel',{attrs:{"perPageCustom":[
        [0, 1],
        [768, 2],
        [992, 3],
        [1200, 4] ],"paginationEnabled":false,"navigationEnabled":true,"navigationNextLabel":"▶&#xFE0E;","navigationPrevLabel":"◀&#xFE0E;"}},_vm._l((_vm.projects),function(project,index){return _c('slide',{key:index},[_c('card',{attrs:{"imgURL":project.icon,"modalData":project}},[_vm._v("\n          "+_vm._s(project.title)+" "),_c('span',[_vm._v(_vm._s(project.tech))])])],1)}))],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-175d627a","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Projects/Projects.vue
// module id = null
// module chunks = 